import { render } from "./ConfigurationOptionsItemHeader.vue?vue&type=template&id=641ed20c&scoped=true"
import script from "./ConfigurationOptionsItemHeader.vue?vue&type=script&lang=js"
export * from "./ConfigurationOptionsItemHeader.vue?vue&type=script&lang=js"

import "./ConfigurationOptionsItemHeader.vue?vue&type=style&index=0&id=641ed20c&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-641ed20c"]])

export default __exports__